import { render, staticRenderFns } from "./EmployeesFoldersMediaEdit.vue?vue&type=template&id=4ab1b305&"
import script from "./EmployeesFoldersMediaEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeesFoldersMediaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports